import browser from '@openclassrooms/utils/browser';

export default function deleteCookie(cookieName: string) {
  const deleteCookieSuffix = '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
  if (browser.document) {
    browser.document.cookie = cookieName + deleteCookieSuffix;
  }
}
